import {
  Card,
  Button,
  Row,
  Col,
  Space,
  Typography,
  message,
  List,
  Tooltip,
} from "antd"
import { useNavigate, useLocation, useParams } from "react-router-dom"
import PanelLayout from "../../../Layout/PanelLayout"
import dayjs from "dayjs"
import apiClient from "../../../Utils/apiClient"
import TableBox from "../../../components/TableBox/TableBox"
import "../../Operations/Operations.scss"

const { Text } = Typography

const SchedulerConfirmation = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { task } = useParams()

  const {
    formValues,
    windowsUpdates,
    chocoData,
    wingetData,
    isEditMode,
    id,
    formData,
  } = location.state || {}

  const handleSubmit = async () => {
    const payload = {
      ...formValues,
    }

    try {
      const result = isEditMode
        ? await apiClient(`schedule/update/${id}`, "PUT", payload)
        : await apiClient("schedule/create", "POST", payload)

      if (result?.success) {
        message.success(result.message || "Scheduler saved successfully")
        navigate("/schedules")
      }
    } catch (err) {
      console.error("Scheduler submit failed", err)
      message.error("Something went wrong. Please try again.")
    }
  }

  const handleBack = () => {
    const routePath = isEditMode ? `/edit-schedule/${id}` : "/add-schedule"
    console.log("formData ======>", formData)

    navigate(routePath, {
      state: {
        fromConfirmation: true,
        formData: formData,
      },
    })
  }

  const windowsColumn = [
    {
      title: "Title",
      dataIndex: "Title",
      key: "title",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Category",
      dataIndex: "Category",
      key: "category",
    },
    {
      title: "Release Date",
      dataIndex: "ReleaseDate",
      key: "releaseDate",
      render: (date) => dayjs(date).format("DD-MM-YYYY"),
    },
    {
      title: "Users",
      dataIndex: "users",
      key: "users",
      render: (users = []) => {
        if (!users || users.length === 0) return "-"

        const names = users.map((u) => u.user)

        if (names.length === 1) {
          return <span className="hostname-link">{names[0]}</span>
        }

        const remainingCount = names.length - 1
        const remainingLabel =
          remainingCount === 1 ? "1 user" : `${remainingCount} users`

        return (
          <Tooltip
            title={
              <div>
                {names.map((name, idx) => (
                  <div key={idx}>{name}</div>
                ))}
              </div>
            }
          >
            <span className="hostname-link">
              {names[0]} + {remainingLabel}
            </span>
          </Tooltip>
        )
      },
    },
  ]

  const chocoColumn = [
    {
      title: "App Name",
      dataIndex: "appName",
      key: "appName",
    },
    {
      title: "Current Version",
      dataIndex: "currentVersion",
      key: "currentVersion",
    },
    {
      title: "Available Version",
      dataIndex: "availableVersion",
      key: "availableVersion",
    },
    {
      title: "Users",
      dataIndex: "users",
      key: "users",
      render: (users = []) => {
        if (!users || users.length === 0) return "-"

        const names = users.map((u) => u.user)

        if (names.length === 1) {
          return <span className="hostname-link">{names[0]}</span>
        }

        const remainingCount = names.length - 1
        const remainingLabel =
          remainingCount === 1 ? "1 user" : `${remainingCount} users`

        return (
          <Tooltip
            title={
              <div>
                {names.map((name, idx) => (
                  <div key={idx}>{name}</div>
                ))}
              </div>
            }
          >
            <span className="hostname-link">
              {names[0]} + {remainingLabel}
            </span>
          </Tooltip>
        )
      },
    },
    {
      title: "Source",
      dataIndex: "source",
      key: "source",
    },
  ]

  const wingetColunm = [
    {
      title: "App Name",
      dataIndex: "appName",
      key: "appName",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Current Version",
      dataIndex: "currentVersion",
      key: "currentVersion",
    },
    {
      title: "Available Version",
      dataIndex: "availableVersion",
      key: "availableVersion",
    },
    {
      title: "Users",
      dataIndex: "users",
      key: "users",
      render: (users = []) => {
        if (!users || users.length === 0) return "-"

        const names = users.map((u) => u.user)

        if (names.length === 1) {
          return <span className="hostname-link">{names[0]}</span>
        }

        const remainingCount = names.length - 1
        const remainingLabel =
          remainingCount === 1 ? "1 user" : `${remainingCount} users`

        return (
          <Tooltip
            title={
              <div>
                {names.map((name, idx) => (
                  <div key={idx}>{name}</div>
                ))}
              </div>
            }
          >
            <span className="hostname-link">
              {names[0]} + {remainingLabel}
            </span>
          </Tooltip>
        )
      },
    },
    {
      title: "Source",
      dataIndex: "source",
      key: "source",
    },
  ]
  console.log("chocoData ============>", chocoData)

  return (
    <PanelLayout
      title={task ? `Confirm ${task.replace(/-/g, " ")}` : "Confirm schedule"}
      subtitle="Review targets and timing before the schedule is saved."
      actions={
        <>
          <Button onClick={() => navigate("/schedules")}>Cancel</Button>
          <Button onClick={handleBack}>Back</Button>
          <Button type="primary" onClick={handleSubmit}>
            {isEditMode ? "Update schedule" : "Save schedule"}
          </Button>
        </>
      }
    >
      <Card className="ops-card" bordered={false}>
        <dl className="ops-meta">
          <div>
            <dt>Name</dt>
            <dd>{formValues?.schedulerName || "—"}</dd>
          </div>
          <div>
            <dt>Task</dt>
            <dd>{formValues?.taskType || "—"}</dd>
          </div>
          <div>
            <dt>Frequency</dt>
            <dd>{formValues?.frequency || "—"}</dd>
          </div>
        </dl>
        <Space direction="vertical" size="middle" style={{ width: "100%" }}>
          <Row gutter={[16, 16]}>
            {task === "app-update" && (
              <>
                {formValues?.applicationCategory?.length > 0 && (
                  <Col span={12}>
                    <Text strong>Application Category:</Text>{" "}
                    {formValues?.applicationCategory?.join(", ")}
                  </Col>
                )}

                {/* Chocolaty Apps */}
                {chocoData && chocoData.length > 0 && (
                  <>
                    <Col span={24}>
                      <Text strong>Chocolaty Apps:</Text>
                    </Col>
                    <Col sm={24} md={24} lg={24} xl={24}>
                      <TableBox
                        title={"Details"}
                        columns={chocoColumn}
                        data={chocoData}
                      />
                    </Col>
                  </>
                )}

                {/* Winget Apps */}
                {wingetData && wingetData.length > 0 && (
                  <>
                    <Col span={24}>
                      <Text strong>Winget Apps:</Text>
                    </Col>
                    <Col sm={24} md={24} lg={24} xl={24}>
                      <TableBox
                        title={"Details"}
                        columns={wingetColunm}
                        data={wingetData}
                      />
                    </Col>
                  </>
                )}
              </>
            )}

            {/* For Windows Update */}
            {task === "windows-updates" && (
              <>
                <Col span={12}>
                  <Text strong>Purpose:</Text>{" "}
                  {formValues?.deploymentPurpose === "available"
                    ? "Available"
                    : "Required"}
                </Col>
                <Col span={12}>
                  <Text strong>Deadline:</Text>{" "}
                  {formValues?.deadlineOffsetHours
                    ? `${Math.floor(formValues.deadlineOffsetHours / 24)} day(s) ${
                        formValues.deadlineOffsetHours % 24
                      } hour(s) after available time`
                    : "As soon as possible"}
                </Col>
                {formValues?.frequency === "patch-tuesday" && (
                  <Col span={12}>
                    <Text strong>Patch Tuesday offset:</Text>{" "}
                    {formValues?.patchTuesdayOffsetDays || 0} day(s)
                  </Col>
                )}
                <Col span={12}>
                  <Text strong>Restart:</Text>{" "}
                  {formValues?.rebootBehavior === "force"
                    ? "Force restart"
                    : formValues?.rebootBehavior === "none"
                    ? "Do not restart"
                    : "Restart if needed"}
                </Col>
                <Col span={12}>
                  <Text strong>Maintenance window:</Text>{" "}
                  {formValues?.maintenanceWindow?.enabled
                    ? `${formValues.maintenanceWindow.startTime || "22:00"}–${
                        formValues.maintenanceWindow.endTime || "05:00"
                      }`
                    : "Not set"}
                </Col>
                {formValues?.taskType === "windows-updates" && (
                  <Col span={12}>
                    <Text strong>Windows collection:</Text>{" "}
                    {formValues?.deviceRole === "windows-client"
                      ? "Windows clients"
                      : formValues?.deviceRole === "windows-server"
                        ? "Windows servers"
                        : "All Windows"}
                  </Col>
                )}
                {formValues?.windowsCategory?.length > 0 && (
                  <Col span={12}>
                    <Text strong>Windows Category:</Text>{" "}
                    {formValues?.windowsCategory?.join(", ")}
                  </Col>
                )}
                {formValues?.releaseStartDate && formValues?.releaseEndDate && (
                  <Col span={12}>
                    <Text strong>Release Date Range:</Text>{" "}
                    {formValues?.releaseStartDate
                      ? dayjs(formValues?.releaseStartDate).format("DD-MM-YYYY")
                      : "-"}{" "}
                    -{" "}
                    {formValues?.releaseEndDate
                      ? dayjs(formValues?.releaseEndDate).format("DD-MM-YYYY")
                      : "-"}
                  </Col>
                )}
                {windowsUpdates && windowsUpdates.length > 0 && (
                  <Col sm={24} md={24} lg={24} xl={24}>
                    <TableBox
                      title={"Details"}
                      columns={windowsColumn}
                      data={windowsUpdates}
                    />
                  </Col>
                )}
              </>
            )}
          </Row>
        </Space>
      </Card>
    </PanelLayout>
  )
}

export default SchedulerConfirmation
